// assistantFlyFollow.js — A FLY PAGE'S NEXT ASKS, and the tour among them.
//
// A page's follow-ups (server ai-boards flySchema.normalizeFollowUps) are next
// asks `{ label, prompt }` — one tap is the next page — and, for a shell that
// runs the quick tour (`capabilities.tour`), the tour itself
// `{ label, action: 'tour' }` on a page about what Symbols is, how the
// workspace works or where to start (Nika 2026-10-28: "if we ask what is
// symbols - this could be offering"). The tour chip RUNS the tour
// (aiStartTour: the home, then the stops) — it is never asked as text.
//
// components/AssistantFlyView.js FlyFollow draws the rows; the row shows only
// with a chip in it.
//
// FRANK: every export is self-contained — no import, no module constant, no
// bare sibling call (`this.call`). `this` is the calling element.

// The chip rows of a page (its state `s`: the canvas's page, or a call's).
// Only a ready page has them. Every row carries EVERY key the chip reads (a
// childrenAs-'state' child falls back to ROOT state for a key it lacks):
//   key        'next' + the follow-up's place (stable while the page stands)
//   label      the ask's words; the tour chip says the onboarding's own
//              "Take the tour" in the member's language
//   prompt     the ask ('' on the tour chip)
//   action     'tour' on the tour chip, else ''
//   source     where the page lives ('session' | 'call'): its ask goes there
//   agentKey, agentName   a call's agent
// The tour chip shows only where the shell runs the tour, never on a call's
// page (the call shows the page to every member; the tour is one person's).
// Fields are read straight off the state, never through `.parse()` (a parse
// peeks: the row's reactive caller would subscribe to nothing).
export const assistantFlyFollowChips = function assistantFlyFollowChips(s) {
  if (!s || typeof s !== 'object' || s.status !== 'ready') return []
  const list = s.followUps
  const n = list && typeof list.length === 'number' ? list.length : 0
  const source = s.source || 'session'
  const tour = source !== 'call' && !!this.call('assistantFlyTourOffered')
  const out = []
  for (let i = 0; i < n && out.length < 4; i++) {
    const f = list[i]
    if (!f || typeof f !== 'object') continue
    if (f.action === 'tour') {
      if (!tour) continue
      const words = this.call('polyglot', 'workspace.onboarding.replayTour')
      out.push({
        key: 'next' + i,
        label: String(words || f.label || ''),
        prompt: '',
        action: 'tour',
        source,
        agentKey: null,
        agentName: null
      })
      continue
    }
    if (!f.label || !f.prompt) continue
    out.push({
      key: 'next' + i,
      label: String(f.label),
      prompt: String(f.prompt),
      action: '',
      source,
      agentKey: s.agentKey || null,
      agentName: s.agentName || null
    })
  }
  return out
}

// A chip, pressed: the tour chip starts the tour; an ask chip asks its page
// where its page lives (assistantFlyPageAct 'ask' — the session, or the call
// and its agent). A tour chip on a call's page, or on a shell without the
// tour, does nothing.
export const assistantFlyFollowPress = function assistantFlyFollowPress(s) {
  if (!s || typeof s !== 'object') return null
  if (s.action === 'tour') {
    if (s.source === 'call' || !this.call('assistantFlyTourOffered')) return null
    return this.call('aiStartTour')
  }
  if (!s.prompt) return null
  return this.call('assistantFlyPageAct', s, 'ask', { prompt: s.prompt })
}
